import { defineStore } from "pinia";
import Vue from "vue";

export const useUserStore = defineStore("user", () => {
  const isWriter = () => {
    return Vue.prototype.$keycloak.hasRealmRole("writer");
  };

  return {
    isWriter,
  };
});
